import { combineReducers } from 'redux';
import channels, { Actions as ActionsChannels } from './channels';
import messages, { Actions as ActionsMessages } from './messages';

const Actions = {
  ActionsChannels,
  ActionsMessages,
};
export { Actions };

export default combineReducers({
  channels,
  messages,
});



// WEBPACK FOOTER //
// ./src/ducks/chat/index.js